import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  error: null,
  editor: {
    title: "",
    description: "",
    callId: "",
    elements: [],
    selectedNode: [],
    edges: [],
    mode: "design" // "design" or "view" mode
  }
};

const ivrStore = createSlice({
  name: "ivr",
  initialState,
  reducers: {
    hasError(state, action) {
      state.error = action.payload;
    },
    setTitle(state, action) {
      state.editor.title = action.payload.title ?? state.editor.title;
    },
    setCallId(state, action) {
      state.editor.callId = action.payload.callId ?? state.editor.callId;
    },
    setDescription(state, action) {
      state.editor.description = action.payload.description ?? state.editor.description;
    },
    setEditorState(state, action) {
      state.editor.elements = action.payload.elements ?? state.editor.elements;
      state.editor.edges = action.payload.edges ?? state.editor.edges;
    },
    setElements(state, action) {
      state.editor.elements = action.payload.elements || state.editor.elements;
      state.editor.edges = action.payload.edges || state.editor.edges;
    },
    selectElement(state, action) {
      state.editor.selectedNode = action.payload.element;
    },
    deleteElement(state, action) {
      const deletedElement = action.payload.element;
      state.editor.elements = state.editor.elements.filter((element) => element.id !== deletedElement.id);
      state.editor.edges = state.editor.edges.filter((edge) => edge.source !== deletedElement.id && edge.target !== deletedElement.id);
    },
    deleteEdge(state, action) {
      const deletedEdge = action.payload.edge;
      state.editor.edges = state.editor.edges.filter((edge) => edge.id !== deletedEdge.id);
    },
    copyElement(state, action) {
      const copiedElement = action.payload.element;
      const newElement = {
        ...copiedElement,
        id: Math.random(),
        position: {
          x: copiedElement.position.x + 50,
          y: copiedElement.position.y + 50
        }
      };
      state.editor.elements = [...state.editor.elements, newElement];
      const copiedEdges = state.editor.edges.filter((edge) => edge.source === copiedElement.id || edge.target === copiedElement.id);
      copiedEdges.forEach((edge) => {
        const newEdge = {
          ...edge,
          id: Math.random(),
          source: edge.source === copiedElement.id ? newElement.id : edge.source,
          target: edge.target === copiedElement.id ? newElement.id : edge.target
        };
        state.editor.edges = [...state.editor.edges, newEdge];
      });
    },
    deleteSelectedElements(state) {
      const selectedElements = state.editor.selectedNode;
      selectedElements.forEach((element) => {
        state.editor.elements = state.editor.elements.filter((node) => node.id !== element.id);
        state.editor.edges = state.editor.edges.filter((edge) => edge.source !== element.id && edge.target !== element.id);
      });
      state.editor.selectedNode = [];
    },
    duplicateElement(state) {
      const nodes = state.editor.selectedNode;
      const newElements = [...state.editor.elements];
      let newNodes = [];
      nodes.forEach((node, index) => {
        const newNode = {
          ...node,
          id: `${node.id.split("-")[0]}-${newElements.length + (index + 1)}`,
          position: { x: node.position.x + 80, y: node.position.y + 50 }
        };
        newElements.push(newNode);
        newNodes.push(newNode);
      });
      state.editor.selectedNode = newNodes;
      state.editor.elements = newElements;
    },
    setEditorMode(state, action) {
      state.editor.mode = action.payload.mode;
    }
  }
});

export const {
  setDescription,
  setTitle,
  setCallId,
  duplicateElement,
  deleteSelectedElements,
  copyElement,
  setElements,
  selectElement,
  deleteElement,
  deleteEdge,
  setEditorMode
} = ivrStore.actions;

export default ivrStore.reducer;
